import { NgModule } from '@angular/core';

import { DialogComponent } from './elements/dialog/dialog.component';
import { DialogTitleComponent } from './elements/dialog-title/dialog-title.component';
import { DialogFooterComponent } from './elements/dialog-footer/dialog-footer.component';
import { DialogHeaderComponent } from './elements/dialog-header/dialog-header.component';
import { DialogContentComponent } from './elements/dialog-content/dialog-content.component';

@NgModule({
  imports: [
    DialogComponent,
    DialogTitleComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    DialogContentComponent,
  ],
  exports: [
    DialogComponent,
    DialogTitleComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    DialogContentComponent,
  ],
})
export class DialogComponentsModule {}
